var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import client from "@irati/utils/services/apollo";
import PBService from "@irati/utils/services";
import userService from "./users";
import getTenantFromPath from "../helpers/getTenantFromPath";
import businessBySubdomain, { businessBySubdomainKey } from "./queries/businessBySubdomain";
import businessQuery, { businessKey } from "./queries/business";
import businessesQuery, { businessesKey } from "./queries/businesses";
import businessCreateMutation, { businessCreateKey } from "./mutations/businessCreate";
import businessUpdateMutation, { businessUpdateKey } from "./mutations/businessUpdate";
import coreErrorHandler from "./errors/coreErrorHandler";
var TenantService = /** @class */ (function (_super) {
    __extends(TenantService, _super);
    function TenantService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getBusinessBySubdomain = function (subdomain, options) {
            if (subdomain === void 0) { subdomain = getTenantFromPath(); }
            if (options === void 0) { options = {}; }
            var variables = { subdomain: subdomain };
            return client.query(__assign(__assign({}, options), { query: businessBySubdomain, variables: variables })).then(function (_a) {
                var data = _a.data;
                return data[businessBySubdomainKey];
            });
        };
        return _this;
    }
    TenantService.prototype.get = function (_a, options) {
        var businessId = _a.businessId, _b = _a.withAdmins, withAdmins = _b === void 0 ? false : _b, _c = _a.withRootTeam, withRootTeam = _c === void 0 ? false : _c;
        if (options === void 0) { options = {}; }
        var variables = { businessId: businessId, withAdmins: withAdmins, withRootTeam: withRootTeam };
        return client.query(__assign(__assign({}, options), { query: businessQuery, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[businessKey];
        });
    };
    TenantService.prototype.list = function (args, options) {
        if (options === void 0) { options = {}; }
        var variables = args;
        return client.query(__assign(__assign({}, options), { query: businessesQuery, variables: variables })).then(function (res) { return res.data[businessesKey]; });
    };
    TenantService.prototype.create = function (_a, options) {
        var data = _a.data, _b = _a.withAdmins, withAdmins = _b === void 0 ? false : _b, _c = _a.withRootTeam, withRootTeam = _c === void 0 ? false : _c;
        if (options === void 0) { options = {}; }
        var variables = { data: data, withAdmins: withAdmins, withRootTeam: withRootTeam };
        return client.mutate(__assign(__assign({}, options), { mutation: businessCreateMutation, variables: variables })).then(function (res) { return res.data[businessCreateKey]; });
    };
    TenantService.prototype.update = function (_a, options) {
        var data = _a.data, _b = _a.withAdmins, withAdmins = _b === void 0 ? false : _b, _c = _a.withRootTeam, withRootTeam = _c === void 0 ? false : _c;
        if (options === void 0) { options = {}; }
        var variables = { data: data, withAdmins: withAdmins, withRootTeam: withRootTeam };
        return client.mutate(__assign(__assign({}, options), { mutation: businessUpdateMutation, variables: variables })).then(function (res) { return res.data[businessUpdateKey]; });
    };
    TenantService.prototype.userCount = function (businessId, options) {
        if (options === void 0) { options = {}; }
        return userService.list({ limit: 1, tenantId: businessId }, options).then(function (_a) {
            var total = _a.total;
            return total;
        });
    };
    return TenantService;
}(PBService));
export default new TenantService({ errorHandlers: [coreErrorHandler] });
